import { useLayoutEffect } from 'preact/hooks';
import { teadsApi } from '../../teads-api';

export function useHideVolumeOnEnd(videoSlot: HTMLElement) {
  useLayoutEffect(() => {
    function onVideoEnd() {
      teadsApi.setSoundControlVisibility(false);
    }

    videoSlot.addEventListener('ended', onVideoEnd);
    return () => videoSlot.removeEventListener('ended', onVideoEnd);
  }, []);
}
